import React, { forwardRef } from 'react';

import ColorsWrapper from '@styles/colors';
import { AlertComponent } from './components/AlertComponent';
import { useManageAlert } from './hooks/useManageAlert';
import { AlertAction, AlertActionStyle, AlertPosition, AlertRef, AlertShowParams } from './types';

export type { AlertRef, AlertShowParams, AlertAction, AlertActionStyle, AlertPosition };

const RenderComponent = ColorsWrapper(AlertComponent);

const Alert = forwardRef<AlertRef>((_, ref) => {
  const { state, hide } = useManageAlert(ref);

  if (!state.showAlert) {
    return null;
  }

  return <RenderComponent {...state} hide={hide} />;
});

Alert.displayName = 'Alert';

export default Alert;
